exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n/* label.el-checkbox {\n\tmin-height:42px;\n} */\n.el-checkbox__inner {\n  border-color: #004588;\n}\n.el-checkbox__inner:hover {\n  border-color: #c0c4cc;\n}\n.field-valid {\n  color: #004588;\n}\n.field-invalid {\n  color: red;\n}\n\n/* .mobile-input {\n  z-index: 20002;\n\n  background-color: aliceblue;\n  opacity: 1;\n} */\n.mobile-container {\n  z-index: 2;\n  position: fixed;\n  top: 60px;\n  left: 0px;\n  width: 100vw;\n  height: 100vh;\n  background-color: aliceblue;\n  opacity: 0.9;\n}\n.avail-opts {\n  padding: 5px 0;\n  color: #9e9e9e;\n  font-size: 14px;\n}\n", ""]);

// exports
